import React from "react";
import { CustomInput } from "reactstrap";

interface CheckBoxProps {
  id?: string;
  label?: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  style?: React.CSSProperties;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  id = "checkbox",
  label,
  name,
  onChange,
  checked = false,
  style
}) => {
  return (
    <CustomInput
      id={id}
      className="mb-3"
      type="checkbox"
      name={name}
      label={label}
      style={style}
      checked={checked}
      onChange={onChange}
    />
  );
};

export default CheckBox;
